import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Grid, Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

const Content = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

const useStyles = makeStyles({
  orderItemDetailsBar: {
    backgroundColor: "#e3e3e3",
    padding: "9px 0px 9px 28px",
    borderRadius: "4px",
    marginBottom: "10px",
  },
  label: {
    fontSize: "12px",
    color: "#000",
    opacity: 0.85,
    textAlign: "left",
  },
  marginTop: {
    marginTop: "10px",
  },
  detail: {
    color: "#000",
    opacity: 0.6,
    textAlign: "left",
  },
  orderInformationLabel: {
    marginTop: "12px !important",
    fontSize: 16,
    color: "rgba(0, 0, 0, 0.89)",
  },
  orderInformationValue: {
    marginBottom: "30px !important",
    fontSize: 14,
    textTransform: "capitalize",
  },
  downloadButton: {
    textTransform: "none",
    fontSize: "12px",
    padding: "4px 12px",
  },
});

const OrderInformation = (props) => {
  const classes = useStyles();
  const { id, productionOrder, activeItem } = props;

  const quotationFiles = productionOrder?.quotation?.quotation_files;

  console.log('quotationFiles in OrderInformation:');
  console.log(activeItem);
  

  const downloadUsingAnchorElement = async (index) => {
    const anchor = document.createElement("a");
    anchor.href = quotationFiles[index].file_url;
    anchor.download = "*";
    document.body.appendChild(anchor);
    anchor.click();
  };

  const downloadItemDetailsFile = () => {
    const anchor = document.createElement("a");
    anchor.href = activeItem.item_details_file_url;
    anchor.download = "custom-size-names.xlsx";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  return (
    <Box className={classes.orderItemDetailsBar}>
      <Grid container>
        <Grid item xs={3}>
          <Box className={classes.label}>Order Number | 订单号</Box>
          <Box className={classes.detail}>{activeItem?.sales_order_id}</Box>
        </Grid>
        <Grid item xs={3}>
          <Box className={classes.label}>Organization Type | 组织类型</Box>
          <Box className={classes.detail}>Default</Box>
        </Grid>
        <Grid item xs={3}>
          <Box className={classes.label}>Client | 客户</Box>
          <Box className={classes.detail}>
            {productionOrder?.organization?.name}
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box className={classes.label}>Invoice To | 开发票</Box>
          <Box className={classes.detail}>{productionOrder?.invoice_to}</Box>
        </Grid>
        <Grid item xs={3} className={classes.marginTop}>
          <Box className={classes.label}>Ship To | 运送到</Box>
          <Box className={classes.detail}>{productionOrder?.ship_to}</Box>
        </Grid>
        <Grid item xs={3} className={classes.marginTop}>
          <Box className={classes.label}>Country | 国家</Box>
          <Box className={classes.detail}>
            {productionOrder?.organization?.country?.name}
          </Box>
        </Grid>
        <Grid item xs={3} className={classes.marginTop}>
          <Box className={classes.label}>Account No | 户口号码</Box>
          <Box className={classes.detail}>-</Box>
        </Grid>
        <Grid item xs={3} className={classes.marginTop}>
          <Box className={classes.label}>Comment |</Box>
          <Box className={classes.detail}>{productionOrder?.comment}</Box>
        </Grid>
        {activeItem?.item_details_file_url && (
          <Grid item xs={3} className={classes.marginTop}>
            <Box className={classes.label}>Custom Size & Names File | 定制尺寸和名称文件</Box>
            <Box className={classes.detail}>
              <Button
                variant="outlined"
                size="small"
                className={classes.downloadButton}
                onClick={downloadItemDetailsFile}
              >
                Download Excel
              </Button>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
   
  );
};

export default OrderInformation;
